var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask_16_7036",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    d: "M15.0034 0.996582C13.6748 -0.332275 11.5205 -0.332275 10.1919 0.996582L9.24219 1.94629L9.24121 1.94727L9.24023 1.94824L0.208984 10.9795L0.155273 11.0398C0.0551758 11.1653 0 11.3218 0 11.4839L0 15.2869L0.00341797 15.3557C0.0375977 15.7173 0.342285 16 0.712891 16L4.51611 16L4.59668 15.9954C4.75635 15.9773 4.90576 15.9058 5.02051 15.7913L14.0522 6.75952L14.0527 6.75879L14.0532 6.75806L15.0034 5.80811L15.0962 5.71167C16.3315 4.3772 16.3003 2.29346 15.0034 0.996582ZM13.5483 5.24609L13.9951 4.79956C14.7402 4.05444 14.7656 2.8623 14.0723 2.08643L13.9951 2.00488C13.25 1.25977 12.0576 1.23413 11.2817 1.92798L11.2002 2.00488L10.7539 2.45142L13.5483 5.24609ZM9.74561 3.45996L1.42627 11.7788L1.42627 14.5735L4.22119 14.5735L12.54 6.25464L9.74561 3.45996Z",
    clipRule: "evenodd",
    fill: "",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Color",
    d: "M15.0034 0.996582C13.6748 -0.332275 11.5205 -0.332275 10.1919 0.996582L9.24219 1.94629L9.24121 1.94727L9.24023 1.94824L0.208984 10.9795L0.155273 11.0398C0.0551758 11.1653 0 11.3218 0 11.4839L0 15.2869L0.00341797 15.3557C0.0375977 15.7173 0.342285 16 0.712891 16L4.51611 16L4.59668 15.9954C4.75635 15.9773 4.90576 15.9058 5.02051 15.7913L14.0522 6.75952L14.0527 6.75879L14.0532 6.75806L15.0034 5.80811L15.0962 5.71167C16.3315 4.3772 16.3003 2.29346 15.0034 0.996582ZM13.5483 5.24609L13.9951 4.79956C14.7402 4.05444 14.7656 2.8623 14.0723 2.08643L13.9951 2.00488C13.25 1.25977 12.0576 1.23413 11.2817 1.92798L11.2002 2.00488L10.7539 2.45142L13.5483 5.24609ZM9.74561 3.45996L1.42627 11.7788L1.42627 14.5735L4.22119 14.5735L12.54 6.25464L9.74561 3.45996Z",
    clipRule: "evenodd",
    fill: "#A0A9A6",
    fillOpacity: 0.8,
    fillRule: "evenodd",
    mask: "url(#mask_16_7036)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Color",
    d: "",
    fill: "#CCCCCC",
    fillOpacity: 0,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEditIcon);
export default __webpack_public_path__ + "static/media/pencil-edit-icon.3ef4fb31f11de0896ecd9c658a75df5f.svg";
export { ForwardRef as ReactComponent };